import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { clientID } from "./Config";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
    <GoogleOAuthProvider clientId={"680681562641-fdgvc2cbpiebs1gir3od3u2e1mvhgn56.apps.googleusercontent.com"}>
      <App />
      </GoogleOAuthProvider>
    </Router>
  </React.StrictMode>
);